import { type MediaObject, type MediaSource } from '@shared/types/media'

const getMediaOrder = (media: MediaObject): number => {
	return Number.isFinite(media.ord) ? media.ord : Number.MAX_SAFE_INTEGER
}

const getMediaObject = (data: MediaSource): MediaObject | undefined => {
	if (!data) {
		return undefined
	}

	if (Array.isArray(data)) {
		return data.reduce<MediaObject | undefined>((selected, media) => {
			if (!media.url) {
				return selected
			}

			if (!selected) {
				return media
			}

			if (media.is_primary !== selected.is_primary) {
				return media.is_primary ? media : selected
			}

			return getMediaOrder(media) < getMediaOrder(selected) ? media : selected
		}, undefined)
	}

	if (data.url) {
		return data
	}

	return undefined
}

export const getMediaUrl = (data: MediaSource): string | undefined => {
	return getMediaObject(data)?.url
}

export const getMediaRoleUrl = <T extends object>(
	media: T | null | undefined,
	roles: string[]
): string | undefined => {
	if (!media) {
		return undefined
	}

	for (const role of roles) {
		const value = media[role as keyof T] as MediaSource
		const url = getMediaUrl(value)
		if (url) {
			return url
		}
	}

	return undefined
}
